import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: 'Registrarse',
		login: 'Iniciar sesión',
		registerReset: 'Restablecer contraseña',
		detailsSubtitle: 'Ingrese sus datos a continuación',
		resetPasswordLink: '¿Olvidó su contraseña?',
		user: 'Nombre de usuario',
		password: 'Contraseña',
		confirmPassword: 'Repetir contraseña',
		key: 'Clave de licencia',
		registerSubmit: 'Registrarse',
		resetSubmit: 'Restablecer',
		loginSubmit: 'Iniciar sesión',
		carousel: {
			title1: 'Nube vs. Local',
			text1:
				'¿La política de seguridad no permite almacenar datos y usar servicios en la nube? ¡Con Webitel, puede construir un centro de contacto en su sitio!',

			title2: 'Multicanal VS Omnicanal',
			text2:
				'¡Esté siempre y en todas partes en contacto con sus clientes! IVR de cualquier complejidad, campañas de interacción saliente, entrante o mensajes en redes sociales: ¡ahora es más fácil que nunca!',

			title3: 'Infraestructura tolerante a fallos',
			text3:
				'No más tiempos de inactividad no planificados. El rápido escalado y la arquitectura tolerante a fallos le permiten atender simultáneamente más de 1000 llamadas de clientes por minuto desde diferentes canales de comunicación.',

			title4: 'Diseño',
			text4:
				'La nueva interfaz minimalista con el panel de administración más fácil de usar que le permite tener acceso rápido a todas las funciones necesarias. Menos clics, más funciones.',

			title5: 'Nuevo módulo de trabajo en grupo de agentes',
			text5:
				'La distribución de llamadas más eficiente. Un agente puede tener varias habilidades a la vez para participar en diferentes campañas. El cliente es atendido solo por profesionales.',

			title6: 'Configuración de permisos',
			text6:
				'Nuevo módulo de gestión de permisos: nuevas oportunidades de control. Los usuarios solo pueden hacer cambios en secciones, así como en acciones.',
		},
	},

	header: {
		logout: 'Cerrar sesión',
		docs: 'Documentación',
	},

	appNavigator: {
		title: 'Aplicaciones Webitel',
		admin: 'Administrador',
		agent: 'Espacio de trabajo del agente',
		supervisor: 'Espacio de trabajo del supervisor',
		audit: 'Auditoría',
		history: 'Historial de llamadas',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Configuración | Configuraciones',
		changePassword: 'Cambiar contraseña',
		language: 'Idioma',
		fallbackLanguage: 'Idioma predeterminado',
		webPhone: 'WebPhone',
		useWebPhone: 'Usar WebPhone',
		useStun: 'Usar STUN',
		notifications: {
			[NotificationType.NewMessageSound]: 'Sonido de nuevo mensaje',
			[NotificationType.NewChatSound]: 'Sonido de nuevo chat',
			[NotificationType.SelfAssignedCallSound]:
				'Sonido de llamada autoasignada',
			[NotificationType.ChatEndSound]: 'Sonido de fin de chat',
			[NotificationType.CallEndSound]: 'Sonido de fin de llamada',
			[NotificationType.TaskEndSound]: 'Sonido de fin de tarea',
			[NotificationType.ChatEndPush]: 'Notificación push de fin de chat',
			[NotificationType.CallEndPush]: 'Notificación push de fin de llamada',
			[NotificationType.TaskEndPush]: 'Notificación push de fin de tarea',
			[NotificationType.SocketCloseSound]: 'Sonido de pérdida de conexión',
		},
		ringtones: {
			title: 'Cambiar tono de llamada',
			ringtone: 'Tono de llamada',
			customRingtone: 'Usar tono de llamada personalizado',
		},
		ringtoneVolume: {
			title: 'Configuración de volumen',
			[RingtoneType.Call]: 'Llamada',
			[RingtoneType.Chat]: 'Chat',
			[RingtoneType.Task]: 'Tarea',
		},
		security: {
			security: 'Seguridad',
			logoutTitle: 'Cerrar sesión de este usuario en otros dispositivos',
		},
	},

	validation: {
		email: 'Debe parecer un correo electrónico',
		required: 'Este campo es requerido',
		sameAs: 'Contraseña incorrecta',
		gatewayHostValidator: 'Debe parecer una dirección IPv4 o FQDN',
		ipValidator: 'Debe parecer una dirección IPv4',
		macValidator: 'Debe parecer una dirección MAC',
		numeric: 'Debe ser numérico',
		requiredArrayValue: 'El array no debe estar vacío',
		isPositiveValue: 'El valor debe ser un número positivo',
		cron: 'Expresión cron inválida',
		hourRange: 'Las horas deben estar entre 00 y 23',
		timerangeStartLessThanEnd:
			'La hora "Desde" no puede ser posterior a "Hasta"',
		timerangeNotIntersect:
			'Los intervalos de tiempo del mismo día no pueden superponerse',
	},

	nav: {
		directory: {
			directory: 'Directorio',
		},
		routing: {
			routing: 'Enrutamiento',
		},
		lookups: {
			lookups: 'Búsquedas',
		},
		ccenter: {
			ccenter: 'Centro de contacto',
		},
		integrations: {
			integrations: 'Integraciones',
		},
		permissions: {
			permissions: 'Permisos',
		},
		system: {
			system: 'Sistema',
		},
	},

	home: {
		dashboard: 'Panel de control',
		welcomeText: '',
		news: 'Noticias',
	},

	objects: {
		all: 'Todos los {entity}',
		administration: 'Administración',
		general: 'General',
		new: 'Nuevo',
		add: 'Añadir',
		create: 'Crear',
		read: 'Leer',
		edit: 'Editar',
		delete: 'Eliminar',
		save: 'Guardar',
		saved: 'Guardado',
		saveAs: 'Guardar como',
		close: 'Cerrar',
		next: 'Siguiente',
		back: 'Atrás',
		change: 'Cambiar',
		name: 'Nombre',
		title: 'Título',
		description: 'Descripción',
		action: 'Acción',
		allow: 'Permitir',
		password: 'Contraseña',
		history: 'Historial',
		copy: 'Copiar',
		copied: 'Copiado al portapapeles!',
		createdAt: 'Creado',
		createdBy: 'Creado por',
		online: 'En línea',
		offline: 'Fuera de línea',
		on: 'Encendido',
		off: 'Apagado',
		ok: 'Ok',
		enabled: 'Habilitado',
		status: 'Estado',
		from: 'De',
		to: 'A',
		importJSON: 'Importar JSON',
		addNew: 'Añadir nuevo',
		provider: 'Proveedor',
		default: 'Por defecto',
		service: 'Servicio',
		tts: 'Texto a Voz',
		stt: 'Voz a Texto',
		key: 'Clave',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: 'Modificado',
		emptyWorkspace: 'Aún no hay registros',
		emptyResultSearch: 'Su búsqueda no produjo resultados',

		deleteConfirmation: {
			title: 'Confirmación de eliminación',
			askingAlert:
				'¿Está seguro de que desea eliminar {count} elemento? | ¿Está seguro de que desea eliminar {count} elementos?',
			undoneActionAlert: 'Esta acción no se puede deshacer.',
			deleteAll: 'TODO',
		},
		generalInfo: 'Información general',
		objectHeader: {},
		directory: {
			directory: 'Directorio',
			passwordInfo:
				'Ingrese el valor solo si desea editarlo (o crear uno nuevo). El campo vacío dejará el valor sin cambios',
			users: {
				users: 'Usuario | Usuarios',
				allUsers: 'Todos los usuarios',
				searchPlaceholder: 'Nombre, login, extensiones, estado',
				login: 'Login',
				extensions: 'Extensiones',
				state: 'Estado',
				DnD: 'DnD',
				status: 'Estado',
				roles: 'Roles',
				tokens: 'Tokens',
				usage: 'Uso',
				expiryDays: 'Días de vigencia',
				expiryDate: 'Fecha de vencimiento',
				roleAdmin: 'Admin',
				license: 'Licencia',
				devices: 'Dispositivos',
				defaultDevice:
					'Dispositivo por defecto (de la lista de dispositivos seleccionados)',
				deviceNotFound: '¿No se encontró el dispositivo?',
				createNewDevice: 'Añadir nuevo',
				variables: 'Variables',
				varKey: 'Clave',
				varVal: 'Valor',
				token: 'Token | Tokens',
				tokenPopupHeader: '¡Su clave de token ha sido creada con éxito!',
				tokenPopupText:
					'Descargue su archivo de clave ahora o copielo. Si no descarga el archivo de clave ahora, no podrá recuperar su clave de token de nuevo. Para ayudar a proteger su seguridad, almacene su clave de token de forma segura y no la comparta.',
				tokenPopupCopy: 'Copiar al portapapeles',
				tokenPopupSave: 'Guardar como TXT',
				userIp: 'IP del usuario',
				userId: 'ID del usuario',
				download: 'Descargar',
				regenerate: 'Regenerar',
				askingAlert:
					'¿Está seguro de que desea regenerar el código? El usuario no podrá iniciar sesión',
				chatName: 'Nombre de visualización de chat',
				temporaryPassword: 'Contraseña temporal',
				communications: 'Comunicaciones',
				generateDevice: 'Generar dispositivo',
				deviceGenerationTitle: 'Generación de dispositivo',
				deviceGeneration:
					'Esta acción creará automáticamente un nuevo dispositivo para este usuario.',
				deviceWasGenerated: 'El dispositivo fue generado',
				deviceGenerationConfirmTitle: 'Confirmar generación de dispositivo',
				generateDeviceConfirmation:
					'Los dispositivos actuales serán reemplazados por el generado. ¿Continuar?',
				authorizationSecurity: 'Autorización y seguridad',
				mustChangePassword:
					'El usuario debe cambiar la contraseña en el primer inicio de sesión.',
				extensionsHelperText: 'La extensión debe contener solo dígitos',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Nombre',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Finalizar todas las sesiones',
					endAllMySessions: 'Finalizar todas mis sesiones',
					endSessionConfirmation: 'Confirmación de finalización de sesión',
					endSessionConfirmationText:
						'¿Está seguro de que desea finalizar todas las sesiones?',
					endMultipleSessionsConfirmationText:
						'¿Estás seguro de que deseas finalizar todas las sesiones de {count} usuarios?',
					tooltip: 'El usuario será desconectado de todos los dispositivos',
				},
			},
			license: {
				customers: 'Clientes',
				license: 'Licencia | Licencias',
				licenseId: 'ID',
				allCustomers: 'Todos los clientes',
				allLicenses: 'Todas las licencias',
				serial: 'Serial',
				product: 'Producto',
				validFrom: 'Válido desde',
				validTill: 'Válido hasta',
				used: 'Usado',
				limit: 'Límite',
				status: 'Estado',
				competitive: 'Competitivo',
				searchPlaceholder: 'Serial, producto',
				domain: 'Dominio',
				daysToExpire: {
					0: 'Expirado',
					30: '30 o menos',
					90: '90 o menos',
					days: ' días',
				},
				importLicense: 'Importar licencia',
				licenseKey: 'Clave de licencia',
			},
			devices: {
				devices: 'Dispositivo | Dispositivos',
				newDevice: 'Nuevo dispositivo',
				newDeviceDescription: 'Descripción del nuevo dispositivo',
				allDevices: 'Todos los dispositivos',
				searchPlaceholder:
					'Nombre, usuario, ID de autenticación & ID de escritorio',
				authId: 'ID de autenticación',
				presence: 'Presencia',
				hotdesk: 'Escritorio caliente',
				hotdeskDevice: 'Dispositivo de escritorio caliente',
				hotdeskDeviceSettings:
					'Configuración del dispositivo de escritorio caliente',
				hotdeskIncorrectInput: 'Nombre de host incorrecto',
				hotdeskInputHint:
					'Para facilitar la identificación de este dispositivo, debería cubrirlo con alias de escritorio amigables. El nombre válido debe contener los siguientes caracteres: A-Z, a-z, 0-9, -, _',
				deviceSettings: 'Configuración del dispositivo',
				hostName: 'Nombre de host',
				phoneInfo: 'Información del teléfono',
				phone: 'Teléfono',
				vendor: 'Proveedor',
				model: 'Modelo',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Historial del dispositivo',
				loggedIn: 'Conectado',
				loggedOut: 'Desconectado',
				state: {
					nonreg: 'No registrado',
					reged: 'Registrado',
					ringing: 'Llamando',
					dialing: 'Llamando',
					dialog: 'Diálogo',
					onhold: 'En espera',
				},
				passwordSetFromAccount:
					'Si no establece contraseña, será la misma que la cuenta',
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Fabricante',
					model: 'Modelo',
					mac: 'Dirección MAC',
					ip: 'Dirección IP',
				},
			},
		},
		permissions: {
			permissions: 'Permisos',
			permissionsRole: 'Rol | Roles',
			allRoles: 'Todos los roles',
			searchPlaceholder: 'rol ..',
			roles: {
				permissions: {
					permissions: 'Permiso de rol | Permisos de rol',
					add: 'Añadir',
					delete: 'Eliminar',
					read: 'Seleccionar',
					write: 'Actualizar',
					eavesdropCall: 'Escuchar llamada',
					playbackRecordFile: 'Reproducir archivo de registro de llamada',
					timeLimitedRecordFile:
						'Reproducir archivo de registro de llamada con límite de tiempo',
					resetActiveAttempts: 'Restablecer intentos activos',
					limitWorkspaceContacts: 'Limitar contactos en el Espacio de trabajo',
					exportDataGrid: 'Exportar datos de la cuadrícula',
					viewCdrPhoneNumbers: 'Ver números de teléfono CDR',
					manageUserRoles: 'Gestionar roles de usuario',
					manageUserLicense: 'Gestionar licencia de usuario',
					changeUserPassword: 'Cambiar contraseña de usuario',
					systemSetting: 'Administrar configuraciones del sistema',
					addDescription: 'Otorga permiso para crear cualquier objeto',
					deleteDescription: 'Otorga permiso para eliminar cualquier objeto',
					readDescription: 'Otorga permiso para seleccionar cualquier objeto',
					writeDescription: 'Otorga permiso para modificar cualquier objeto',
					eavesdropCallDescription:
						'Otorga permiso para escuchar una conversación activa',
					playbackRecordFileDescription:
						'Otorga permiso para reproducir archivos de registro de llamada',
					timeLimitedRecordFileDescription:
						'Otorga permiso para reproducir archivos de registro de llamada con límite de tiempo',
					resetActiveAttemptsDescription:
						'Otorga permiso para restablecer intentos activos',
					limitWorkspaceContactsDescription:
						'Limita el permiso para ver la lista de contactos en el Espacio de trabajo',
					exportDataGridDescription:
						'Otorga permiso para exportar datos de la cuadrícula a un archivo',
					viewCdrPhoneNumbersDescription: 'Ver números de teléfono CDR',
					manageUserRolesDescription:
						'Otorga permiso para gestionar un conjunto de roles de usuario',
					manageUserLicenseDescription:
						'Otorga permiso para gestionar un conjunto de licencia de usuario',
					changeUserPasswordDescription:
						'Otorga permiso para cambiar la contraseña de los usuarios',
					systemSettingDescription:
						'Otorga permiso para acceder y gestionar la sección de Configuración',
					schemeVariables: 'Administrar variables globales',
					controlAgentScreen: 'Controlar la pantalla del agente',
					schemeVariablesDescription:
						'Otorga permiso para acceder y gestionar la sección de Variables globales',
				},
				addPermission: 'Añadir permiso de rol',
				usage: 'Uso',
				applicationsAccess: {
					applicationsAccess: 'Acceso a aplicaciones | Acceso a aplicaciones',
					access: 'Acceso',
				},
			},
			object: {
				object: 'Objetos',
				allObjects: 'Todos los objetos',
				ObAC: 'Gestionado por operaciones',
				RbAC: 'Gestionado por registros',
				operations: 'Operaciones',
				searchPlaceholder: 'objeto ..',
				newPermissionRole: 'Nuevo otorgante',
				rbacDefault: 'Acceso por defecto basado en registro',
				grantor: 'Concedente',
				grantee: 'Concedido',
				create: 'Crear',
				delete: 'Eliminar',
				accessMode: {
					1: 'Prohibido',
					2: 'Permitir',
					3: 'Permitir con delegación',
				},
			},
		},
		lookups: {
			lookups: 'Búsquedas',
			skills: {
				skills: 'Habilidad | Habilidades',
				capacity: 'Capacidad',
				minCapacity: 'Capacidad mínima',
				minCapacityLessOrEqualToMaxCapacityValidator:
					'Debe ser menor o igual a la capacidad máxima',
				maxCapacity: 'Capacidad máxima',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					'Debe ser mayor o igual a la capacidad mínima',
				lvl: 'Nivel',
				agentSkills: 'Habilidad de agente | Habilidades de agentes',
				allSkills: 'Todas las habilidades',
				state: 'Estado',
				stateForAll: 'Estado para todos',
				changeSkillTo: 'Cambiar habilidad a',
				changeAgentsSkill: 'Cambiar habilidad del agente',
				totalAgents: 'Total de agentes',
				activeSkillAgents: 'Agentes con habilidad activa',
				assignSkillToAgents: 'Asignar habilidad a agentes',
				assignAgent: 'Asignar agente',
				selectCapacityAndState: 'Seleccionar capacidad y estado',
			},
			buckets: {
				buckets: 'Caja | Cajas',
				allBuckets: 'Todas las cajas',
				addBucket: 'Añadir caja',
			},
			blacklist: {
				blacklist: 'Lista | Listas',
				allBlacklists: 'Todas las listas',
				number: 'Número | Números',
				newNumber: 'Nuevo número',
				numbersCount: 'Números',
				expireAt: 'Expirar',
				temporary: 'Temporal',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					'Números importados: {imported}. Duplicados omitidos: {skipped}.',
			},
			media: {
				mediaFiles: 'Archivo de medios | Archivos de medios',
				allMediaFiles: 'Todos los archivos de medios',
				createdAt: 'Creado',
				format: 'Formato',
				size: 'Tamaño',
				textToSpeech: 'Texto a voz',
				popupSettings: 'Configuración',
				lang: 'Idioma',
				voice: 'Voz',
				token: 'Token',
				key: 'Clave',
				dragPlaceholder: 'Arrastrar y soltar archivos',
				dragPlaceholderHere: 'aquí.',
				tts: {
					hint: 'Crear un archivo de audio',
					textType: {
						textType: 'Tipo de texto',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Ubicación | Ubicaciones',
				allRegions: 'Todas las ubicaciones',
			},
			timezone: {
				timezone: 'Zona horaria | Zonas horarias',
			},
			calendars: {
				calendars: 'Calendario | Calendarios',
				allCalendars: 'Todos los calendarios',
				searchPlaceholder: 'Nombre, descripción...',
				timezone: 'Zona horaria',
				start: 'Inicio',
				end: 'Fin',
				workWeek: 'Semana laboral',
				specialTime: 'Tiempo especial',
				holidays: 'Vacaciones | Días festivos',
				date: 'Fecha',
				repeat: 'Repetir',
				fulltime: 'Temporario',
				everyYear: 'Repetir cada año',
				newHoliday: 'Nuevo día festivo',
				mon: 'Lunes',
				tue: 'Martes',
				wed: 'Miércoles',
				thu: 'Jueves',
				fri: 'Viernes',
				sat: 'Sábado',
				sun: 'Domingo',
				workingTime: 'Tiempo de trabajo',
				workStart: 'Hora de inicio de trabajo',
				workStop: 'Hora de fin de trabajo',
			},
			communications: {
				communications: 'Tipo de comunicación | Tipos de comunicación',
				allCommunications: 'Todos los tipos de comunicación',
				addCommunication: 'Añadir comunicación',
				missingCommunication: 'Por favor, añada un tipo de comunicación',
				code: 'Código',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Teléfono',
					[EngineCommunicationChannels.Email]: 'Correo electrónico',
					[EngineCommunicationChannels.Messaging]: 'Mensajería',
				},
			},
			pauseCause: {
				pauseCause: 'Causas de pausa',
				allPauseCause: 'Todos los motivos de pausa de agente',
				limit: 'Límite (min)',
				min: 'min',
				allowAdmin: 'El administrador puede cambiar este estado',
				allowSupervisor: 'El supervisor puede cambiar este estado',
				allowAgent: 'El agente puede cambiar este estado',
			},
			quickReplies: {
				quickReplies: 'Respuesta rápida | Respuestas rápidas',
			},
			activityTypes: {
				activityTypes: 'Tipo de actividad | Tipos de actividad',
			},
		},
		routing: {
			routing: 'Enrutamiento',
			ip: 'IP',
			protocol: 'Protocolo',
			port: 'Puerto',
			configuration: 'Configuración',
			schema: 'Esquema de flujo',
			json: 'JSON',

			flow: {
				flow: 'Esquema de flujo | Esquemas de flujo',
				allFlowSchemas: 'Todos los esquemas de flujo',
				createFlowSelectionPopup: 'Crear nuevo flujo',
				createNew: '¿Crear nuevo?',
				editor: 'Editor',
				diagram: {
					diagram: 'Diagrama',
					description:
						'Crear nuevo flujo usando la herramienta Webitel Flow Diagram',
				},
				code: {
					code: 'Código',
					description:
						'Crear nuevo flujo usando un esquema JSON en el editor de código',
				},
				askingAlert: '¿Desea guardar los cambios realizados en "{name}" ?',
			},

			dialplan: {
				dialplan: 'Dialplans',
				dialplanRules: 'Reglas de dialplan',
				pattern: 'Número de destino',
				dialplanRule: 'Regla de dialplan',
				position: 'Posición',
				allowTransfer: 'Permitir transferencia',
			},

			chatplan: {
				chatplan: 'Chatplan | Chatplans',
				allChatplans: 'Todos los chatplans',
			},

			gateways: {
				gateways: 'Puerta de enlace | Puertas de enlace',
				allGateways: 'Todas las puertas de enlace',
				trunkingGateway: 'Puerta de enlace de troncalización',
				registerGateway: 'Puerta de enlace de registro',
				stateSuccess: 'Éxito',
				stateFailed: 'Fallido',
				stateProgress: 'En progreso',
				stateNonreg: 'No registrado',
				proxy: 'Proxy',
				searchPlaceholder: 'búsqueda de puerta de enlace...',
				host: 'Host',
				trunkingACL: 'Lista de control de acceso de troncalización',
				hostnameTrunking: 'Nombre de host/Puerta de enlace del servidor o IP',
				hostnameRegister:
					'Nombre de host/Servidor/Puerta de enlace del registrador o IP',
				expire: 'Expirar',
				authID: 'Nombre de usuario',
				account: 'Cuenta',
				outboundProxy: 'Nombre de host o IP del proxy de salida',
				newGateway: 'Nueva puerta de enlace',
				newGatewayDescription: 'Descripción de la nueva puerta de enlace',
				SIPregistrations: 'Registro SIP',
				SIPregistrationsDescription: 'Descripción del registro SIP',
				SIPtrunking: 'Troncalización SIP',
				SIPtrunkingDescription: 'Descripción de la troncalización SIP',
			},
			chatGateways: {
				templates: {
					templates: 'Plantilla | Plantillas',
					title: 'Nombre del miembro del espacio de trabajo',
					close: 'Mensaje de finalización de chat',
					join: 'Mensaje de unión del agente',
					left: 'Mensaje de desconexión del agente',
					filePolicyFail: 'Formato de archivo prohibido',
				},
				chatGateways: 'Puerta de enlace de chat | Puertas de enlace de chat',
				allChatGateways: 'Todas las puertas de enlace de chat',
				telegramBot: {
					telegramBot: 'Bot de Telegram',
				},
				telegramApp: {
					telegramApp: 'Aplicación de Telegram',
					signedAs: 'Estás firmado como',
					joinTelegram: 'Inicia sesión en Telegram',
					signOut: 'Cerrar sesión en Telegram',
					metadata: {
						apiId: 'ID de API',
						apiHash: 'Hash de API',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Meta',
					addOrRemovePages: 'Añadir o eliminar páginas',
					accounts: 'Cuentas',
					metadata: {
						clientId: 'ID de aplicación',
						clientSecret: 'Secreto de aplicación',
						apiVersion: 'Versión de API',
						apiVersionHint: 'Formato: vXX.X (por ejemplo, v24.0)',
					},
					facebook: {
						pages: 'Páginas de Facebook',
						subscription: 'Suscripción de webhook',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Seguimiento de comentarios',
						mentions: 'Seguimiento de menciones',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Token',
						status: 'Estado',
						number: 'Número de teléfono',
						review: 'Revisión',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Estilo',
						btnBackColor: 'Color de fondo del botón',
						btnFontColor: 'Color de fuente del botón',
					},
				},
				webchat: {
					webchat: 'Chat web',
					copyCode: 'Copiar código para el sitio',
					copyCodeHint:
						'Debe regenerar y reinsertar el código del Widget en el sitio web cada vez después de la modificación de la configuración del Widget',
					metadata: {
						mediaMaxSize: 'Tamaño máximo de medios (MB)',
					},
					view: {
						view: 'Vista',
						borderRadius: 'Forma del botón',
						language: 'Idioma',
						position: 'Posición',
						btnColor: 'Color del botón',
						logoUrl: 'URL del logo',
						logoHint: "El formato de logo admitido es 'JPEG' o 'PNG', 24x24px",
						rounded: 'Redondeado',
						square: 'Cuadrado',
						right: 'Derecha',
						left: 'Izquierda',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Clave de sitio',
						secret: 'Clave secreta',
						threshold: 'Umbral',
						showFlag: 'Mostrar insignia de reCAPTCHA',
					},
					chat: {
						chat: 'Chat',
						openTimeout: 'Tiempo de apertura',
						openTimeoutSec: 'Tiempo de apertura (seg)',
					},
					appointment: {
						appointment: 'Cita',
						days: 'Días',
						availableAgents: 'Agentes disponibles',
						showEmailField: 'Mostrar campo de correo electrónico',
						showMessageField: 'Mostrar campo de mensaje',
						resultPageText: 'Texto de página de resultado',
						headingText: 'Texto de encabezado',
						subheadingText: 'Texto de subencabezado',
						showDefaultHeading:
							'Mostrar encabezado y subencabezado por defecto en la página de resultado',
					},
					alternativeChannels: {
						alternativeChannels: 'Canales alternativos',
						title: 'Canales de mensajería',
						email: 'Correo electrónico',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Messenger',
					},
					call: {
						title: 'Llamada en línea',
						url: 'Punto final WebSocket',
					},
				},
				customChat: {
					customChat: 'Chat personalizado',
					customChatGateway: 'Puerta de enlace de chat personalizado',
					appSecretHint: 'Al modificar este campo interrumpirá la integración',
					metadata: {
						appSecret: 'Secreto de aplicación',
						callback: 'Retorno de llamada',
					},
				},
				uri: 'URI',
				newChatGateway: 'Nueva puerta de enlace de chat',
				metadata: {
					apiKey: 'Clave de API',
					baseUrl: 'URL base',
					allowOrigin: 'Origen permitido',
					readTimeout: 'Tiempo de lectura (seg)',
					writeTimeout: 'Tiempo de escritura (seg)',
					handshakeTimeout: 'Tiempo de handshacke (seg)',
					botName: 'Nombre del bot',
					telegramToken: 'Token de API de BOT de Telegram',
				},
			},

			callflow: {
				callflow: 'Flujo de llamada',
			},
		},

		ccenter: {
			ccenter: 'Centro de contacto',

			agents: {
				agents: 'Agente | Agentes',
				supervisors: 'Supervisor | Supervisores',
				admins: 'Administrador | Administradores',
				subordinates: 'Agente subordinado | Agentes subordinados',
				allAgents: 'Todos los agentes',
				chatCount: 'Contador de chats',
				taskCount: 'Contador de tareas',
				progressiveCountValidator:
					'El valor debe ser mayor que 1 o estar vacío',
				extraChatCount: 'Recuento de chats adicionales',
				state: 'Estado',
				isSupervisor: 'Supervisor',
				stateTime: 'Tiempo de estado',
				statusType: 'Tipo de estado',
				addSkill: 'Añadir habilidad',
				editSkill: 'Editar habilidad',
				statusHistory: 'Historial de estado',
				historyState: 'Estado',
				payload: 'Causa',
				addSubordinate: 'Añadir agente subordinado',
				historyChannel: 'Canal',
				historyFrom: 'De',
				historyTo: 'A',
				historyDuration: 'Duración',
				emptyPopup: 'Por favor, compruebe la consulta de filtros',
				status: {
					online: 'En línea',
					offline: 'Fuera de línea',
					pause: 'Pausa',
					breakOut: 'Salida de pausa',
				},
				wfm: 'WFM',
				workingConditions: 'Condiciones de trabajo',
				pauseTemplate: 'Plantilla de pausa',
				agentScreenControl: 'Control de pantalla del agente',
				agentScreenControlHint:
					'No se puede desactivar mientras la configuración del equipo esté activada.',
			},

			auditors: {
				auditors: 'Auditor | Auditores',
			},

			teams: {
				teams: 'Equipo | Equipos',
				allTeams: 'Todos los equipos',
				strategy: 'Estrategia',
				parameters: 'Parámetros',
				maxNoAnswer: 'Máximo de actividades perdidas',
				callTimeout: 'Tiempo de aceptación de llamada',
				inviteChatTimeout: 'Tiempo de aceptación de chat',
				wrapUpTime: 'Tiempo de cierre',
				noAnswerDelayTime: 'Tiempo de retraso después de la actividad perdida',
				taskAcceptTimeout: 'Tiempo de aceptación de tarea',
				strategies: {
					random: 'Aleatorio',
					fewestCalls: 'Agente con menos llamadas',
					leastTalkTime: 'Agente con menos tiempo de habla',
					topDown: 'De arriba hacia abajo',
					roundRobin: 'Round robin',
					roundRobinBucket: 'Round robin bucket',
					longestIdleAgent: 'Agente con más tiempo inactivo',
					skillCapacity: 'Por nivel de habilidad',
				},
				hooks: {
					eventTypes: {
						agentStatus: 'Estado del agente cambiado',
					},
				},
				flows: {
					addFlowSchema: 'Añadir esquema de flujo',
					editFlowSchema: 'Editar esquema de flujo',
				},
				supervisors: {
					addSupervisor: 'Añadir supervisor',
					editSupervisor: 'Editar supervisor',
				},
				agents: {
					addAgent: 'Añadir agente',
					editAgent: 'Editar agente',
				},
			},

			members: {
				members: 'Miembro | Miembros',
				allMembers: 'Todos los miembros',
				addMember: 'Añadir miembro',
				destination: 'Destino',
				communications: 'Comunicaciones',
				display: 'Número de visualización',
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Intentos',
				emptyWorkspace: 'No se encontraron miembros',
				resetMembers: {
					resetMembers: 'Restablecer miembros',
					description: {
						question:
							'¿Está seguro de que desea reiniciar los intentos fallidos',
						all: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} sin ningún límite de fecha?`,
						filtered: ({ named, linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} desde\n${named('dateFrom')} hasta ${named('dateTo')}\nsegún los filtros aplicados y los resultados de la búsqueda?`,
						selected: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')}?`,
					},
					descriptionCount: 'Se verán afectados {count} registros.',
					emptyDescription:
						'No hay intentos fallidos que coincidan con los filtros actuales. No hay nada que reiniciar.',
					reset: 'Restablecer',
					successResetCount: 'Se restablecieron con éxito {count} miembros',
				},
				exportMembers: {
					exportMembers: 'Exportar miembros',
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					name: 'Nombre',
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Cubo',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Prioridad de tipos de comunicación',
					code: 'Cubo',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: 'Aplicar cambios',
				message: 'Los cambios se aplicarán a {count} registros. ¿Está seguro?',
			},

			queues: {
				queues: 'Cola | Colas',
				allQueues: 'Todas las colas',
				type: 'Tipo',
				state: 'Estado',
				active: 'Activo',
				notActive: 'No activo',
				activeCalls: 'Llamadas activas',
				waiting: 'En espera',
				ringtone: 'Tonazo',
				priority: 'Prioridad',
				teams: 'Equipo | Equipos',
				tags: 'Etiquetas',
				newQueue: 'Nueva cola',
				saveBeforeAddingRecords:
					'Complete los campos obligatorios de la cola antes de agregar registros',
				blacklist: 'Lista de parada',
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: 'Descripción de la nueva cola',
				outboundIVRQueue: 'Cola IVR de salida',
				outboundIVR: 'IVR de salida',
				outboundIVRQueueDescription:
					'Un IVR de salida permite a una organización iniciar la atención de clientes a través de múltiples canales, como llamadas de voz automatizadas, mensajes SMS, correo electrónico o publicaciones en redes sociales utilizando notificaciones personalizadas.',
				inboundQueue: 'Cola de entrada',
				inboundQueueDescription:
					'Una cola de entrada es donde los llamantes se colocan en espera, en una cola, mientras esperan hablar con un agente vivo.',
				offlineQueue: 'Cola fuera de línea',
				offlineQueueDescription:
					'Una cola fuera de línea da a los llamantes la opción de dejar de esperar en espera, introduzcan su número de teléfono y reciban una llamada de vuelta tan pronto como sea su turno.',
				previewDialer: 'Dialer de vista previa',
				previewDialerDescription: 'Vise la contacto antes de auto-dialearlos.',
				progressiveDialer: 'Dialer progresivo',
				progressiveDialerDescription:
					'El dialer progresivo minimiza el tiempo perdido entre llamadas auto-dialeando un número de la lista de llamadas tan pronto como un agente esté disponible.',
				predictiveDialer: 'Dialer predictivo',
				predictiveDialerDescription:
					'Un dialer predictivo llama a múltiples números al mismo tiempo. Tan pronto como un cliente responde, se conecta con ellos un agente.',
				chatInboundQueue: 'Cola de chat de entrada',
				chatInboundQueueDescription:
					'Lo mismo que la cola de entrada, pero con chats',
				imChatQueue: 'Cola de chat IM',
				imChatQueueDescription:
					'Lo mismo que la cola de chat, pero para mensajería instantánea',
				inboundJobQueue: 'Cola de tarea de entrada',
				inboundJobQueueDescription: 'Cola de tarea de entrada',
				outboundJobQueue: 'Cola de tarea de salida',
				outboundJobQueueDescription: 'Cola de tarea de salida',
				strategy: 'Estrategia',
				timezone: 'Zona horaria',
				callLimit: 'Límite de llamadas',
				variables: 'Variables',
				members: 'Miembro | Miembros',
				params: 'Parámetros',
				discardAbandonedAfter: 'Descartar abandonado después de',
				maxIdleAgent: 'Tiempo de espera de respuesta del agente',
				maxIdleClient: 'Tiempo de espera de respuesta del cliente',
				maxIdleDialog: 'Tiempo de espera máximo',
				timeoutWithNoAgents: 'Tiempo de espera con ningún agente',
				timeBaseScore: 'Puntuación basada en el tiempo',
				endless: 'Sin fin',
				stickyAgent: 'Agente pegajoso',
				stickyAgentSec: 'Agente pegajoso (seg)',
				autoAnswerTone: 'Tono de advertencia de respuesta automática',
				varKey: 'Clave',
				varVal: 'Valor',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: 'Ofrecido en',
				destination: 'Destino | Destinos',
				expire: 'Expirar',
				originateTimeout: 'Tiempo de origen',
				maxAgentLine: 'Líneas máximas de agente',
				maxAgentLose: 'Llamadas perdidas máximas de agente',
				minAttempts: 'Intentos de predicción mínimos',
				maxAbandonedRate: 'Porcentaje máximo de abandono %',
				loadFactor: 'Factor de carga',
				abandonRateAdjustment: 'Ajuste de tasa de abandono',
				playbackSilence: 'Silencio de reproducción',
				targetAbandonedRate: 'Tasa de abandono objetivo %',
				maxWaitTime: 'Tiempo máximo de espera',
				maxWaitingSize: 'Tamaño máximo de espera',
				waitBetweenRetries: 'Esperar entre reintentos',
				waitBetweenRetriesDesc: 'Ordenar reintentos por descendiente',
				strictCircuit: 'Circuito estricto',
				retryAbandoned: 'Reintentar abandonado',
				playbackFile: 'Archivo de reproducción',
				timeout: 'Tiempo de espera',
				maxNumberOfRetry: 'Número máximo de reintentos',
				minDuration: 'Duración mínima de llamada exitosa',
				maxAttempts: 'Intentos máximos',
				minOnlineAgents:
					'Acceso a la pausa cuando hay más agentes en línea que',
				waitForResultStatus: 'Esperar estado de resultado',
				bucketPriority: 'Prioridad',
				amd: 'AMD',
				enabled: 'Usar AMD',
				ai: 'Inteligencia artificial',
				positiveLabels: 'Etiquetas positivas',
				aiPlayback: 'Archivo de reproducción',
				allowNotSure: 'Transferir NO SABE a un agente',
				silenceNotSure: 'Transferir silencio a un agente',
				allowGreetingAgent: 'Permitir saludo del agente',
				preSchema: 'Esquema pre-ejecutivo',
				afterSchema: 'Esquema post-ejecutivo',
				maxCalls: 'Tareas máximas',
				dialingRate: 'Tasa de dialado',
				maxCallsHint: 'Si el valor es 0, no se realizan tareas',
				recordings: 'Grabación',
				recordAll: 'Iniciar grabación después de la respuesta',
				perNumbers: 'Intentos de dialado por cada número de teléfono',
				maxWordLength: 'Longitud máxima de palabra (ms)',
				maxNumberOfWords: 'Número máximo de palabras',
				betweenWordsSilence: 'Silencio entre palabras (ms)',
				minWordLength: 'Longitud mínima de palabra (ms)',
				totalAnalysisTime: 'Tiempo total de análisis (ms)',
				silenceThreshold: 'Umbral de silencio (ms)',
				afterGreetingSilence: 'Silencio después del saludo (ms)',
				greeting: 'Saludo (ms)',
				initialSilence: 'Silencio inicial (ms)',
				statisticTime: 'Intervalo de recálculo',
				communications: 'Tipo de comunicación',
				manualDistribution: 'Distribución manual',
				lastMessageTimeout: 'Tiempo de espera desde el último mensaje',
				stickyIgnoreStatus: 'Ignorar estado del agente',
				ignoreCalendar: 'Ignorar calendario',
				resourceStrategy: {
					resourceStrategy: 'Estrategia de recursos',
					priorityBased: 'Basado en prioridad',
					evenDistribution: 'Distribución uniforme',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Restablecer intentos',
					attemptType: 'Tipo de intento',
					idleTime: 'Tiempo inactivo (min)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Llamadas',
					attemptsCount: 'Intentos',
				},
				processing: {
					processing: 'Procesamiento',
					enabled: 'Esperando resultado de llamada',
					formSchema: 'Esquema de procesamiento dinámico',
					sec: 'Tiempo de postprocesamiento (seg)',
					renewalSec:
						'Ofrecer prolongar el postprocesamiento cuando queden (seg)',
					allowProlongation: 'Permitir prolongación del postprocesamiento',
					autosave: 'Permitir autoguardado del postprocesamiento',
					repeatsNumber: 'Número de repeticiones',
					prolongationTimeSec: 'Tiempo para prolongación (seg)',
					isTimeoutRetry: 'Reintentar hasta tiempo de espera',
				},
				queueStrategy: {
					fifo: 'FIFO (Primero en entrar, primero en salir)',
					lifo: 'LIFO (Último en entrar, primero en salir)',
					strict_fifo: 'FIFO estricto (Primero en entrar, primero en salir)',
				},
				logs: {
					logs: 'Registro | Registros',
					destination: 'Destino',
					offeringAt: 'Ofrecido',
					joinedAt: 'Inicio',
					leavingAt: 'Fin',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: 'Número de vista',
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Intentos',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Ganchillo | Ganchillos',
					event: 'Evento',
					eventTypes: {
						joined: 'Unido',
						answered: 'Respondido',
						offering: 'Ofrecido',
						bridged: 'Enlazado',
						missed: 'Perdido',
						leaving: 'Saliendo',
						processing: 'Procesando',
						active: 'Activo',
					},
				},
				skills: {
					editSkill: 'Editar habilidad',
					addSkill: 'Añadir habilidad',
				},
				buckets: {
					addBucket: 'Añadir caja',
					editBucket: 'Editar caja',
				},
			},

			res: {
				res: 'Recurso | Recursos',
				allRes: 'Todos los recursos',
				reserve: 'Reservar',
				searchPlaceholder: 'nombre, puerta de enlace..',
				cps: 'CPS',
				limit: 'Límite',
				cidType: 'Tipo de CID',
				ignoreEarlyMedia: 'Ignorar medios tempranos',
				numbers: 'Número | Números',
				displayNumbers: 'Números de visualización',
				failure: 'Fallo',
				maxErrors: 'Respuestas de fallo máximas',
				errorCodes: 'Respuestas de fallo de solicitud',
				patterns: 'Patrón de número de destino',
				priority: 'Prioridad',
				reserveResource: 'Reservar recurso',
				failureDialDelay: 'Retraso de dialado de fallo',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Grupo de recursos | Grupos de recursos',
				allResGroups: 'Todos los grupos de recursos',
				searchPlaceholder: 'nombre de grupo de recursos..',
				addResGroup: 'Añadir grupo de recursos',
				editResGroup: 'Editar grupo de recursos',
				strategy: 'Estrategia',
				timerange: 'Rango de tiempo',
				timerangeFrom: 'Desde',
				timerangeTo: 'Hasta',
			},
		},

		integrations: {
			integrations: 'Integraciones',
			emptyWorkspace: 'Aún no hay perfiles',

			storage: {
				storage: 'Almacenamiento',
				allStorages: 'Todos los almacenamientos',
				type: 'Tipo',
				maxSize: 'Espacio de almacenamiento (GB)',
				expireDays: 'Vida útil (días)',
				priority: 'Prioridad',
				newStorage: 'Nuevo almacenamiento',
				newStorageDescription: 'Descripción del nuevo almacenamiento',
				local: 'Local',
				s3: 'Caja S3',
				digitalOcean: 'Espacios Digital Ocean',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Configuración',
				pathPattern: 'Patrón de ruta',
				localFolder: 'Carpeta local',
				s3Key: 'ID de clave',
				s3Access: 'Clave de acceso',
				bucket: 'Caja',
				region: 'Región',
				oceanKey: 'ID de clave',
				oceanAccess: 'Clave de acceso',
				backblazeAccount: 'ID de cuenta',
				backblazeKey: 'Clave de aplicación',
				backblazeBucketId: 'ID de caja',
				dropboxKey: 'Token de acceso',
				driveFolder: 'Nombre de carpeta',
				driveEmail: 'Correo electrónico de Google',
				driveKey: 'Clave privada',
				s3Endpoint: 'Punto final',
			},

			storagePolicies: {
				storagePolicies:
					'Política de almacenamiento | Políticas de almacenamiento',
				mimeTypes: 'Tipos MIME',
				retentionDays: 'Días de retención',
				maxDownloadSpeed: 'Velocidad de descarga máxima (kbps)',
				maxUploadSpeed: 'Velocidad de carga máxima (kbps)',
				maxUploadSize: 'Tamaño de carga máximo (bytes)',
				applyToFiles: 'Aplicar días de retención a archivos existentes',
				applyPopupMessage:
					'El nuevo tiempo de retención se aplicará a los archivos existentes según la política. ¿Desea continuar?',
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'llamada',
					[StorageUploadFileChannel.ChatChannel]: 'chat',
					[StorageUploadFileChannel.MediaChannel]: 'medio',
					[StorageUploadFileChannel.MailChannel]: 'correo',
					[StorageUploadFileChannel.LogChannel]: 'registro',
					[StorageUploadFileChannel.ScreenRecordingChannel]:
						'grabaciones de pantalla',
				},
				encryptFile: 'Encriptar archivos nuevos',
				encryptFileHint:
					'¡No podrá descifrar archivos si se pierde la clave de cifrado! Los registros solo se pueden acceder a través de API o interfaz.',
				encryptionAlertTitle: 'Alerta de cifrado',
				encryptionEnableMessage: 'Solo se cifrarán los archivos nuevos.',
				encryptionDisableMessage:
					'Los archivos antiguos permanecerán cifrados.\nLos archivos nuevos no se cifrarán.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Perfil cognitivo | Perfiles cognitivos',
				properties: {
					region: 'Región',
					locale: 'Idioma',
				},
			},
			emailProfiles: {
				emailProfiles:
					'Perfil de correo electrónico | Perfiles de correo electrónico',
				mailbox: 'Buzón',
				smtpPort: 'Puerto SMTP',
				imapPort: 'Puerto IMAP',
				smtpHost: 'Host SMTP',
				imapHost: 'Host IMAP',
				fetchInterval: 'Intervalo de actualización',
				listen: 'Escuchar',
				authType: 'Tipo de autenticación',
				authenticatedAs: 'Autenticado como',
			},
			singleSignOn: {
				singleSignOn: 'Perfil SSO | Perfiles SSO',
				provider: 'Proveedor',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Ámbitos',
				scopesPlaceholder: 'Escriba un ámbito y presione Enter',
				inspect: 'Inspect',
				inspectHint: 'Enviar una solicitud al proveedor y recibir un token',
				token: 'Token',
				showToken: 'Mostrar token',
				inspectDescription:
					'Enviar una solicitud al proveedor y recibir un token',
				mapping: 'Mapeo',
				mappingKeyHint:
					'Proporcione un atributo de usuario (p. ej., email, username, extension u otro) para usarlo como clave de búsqueda.',
			},

			importCsv: {
				importCsv:
					'Importar CSV desde archivo | Importaciones de CSV desde archivo',
				allImportsCsv: 'Todos los datos de importación de archivos CSV',
				source: 'Destino de importación',
				settings: 'Configuración',
				mappings: 'Asignaciones de campos',
				mappingsHint:
					'En esta sección debe proporcionar los nombres de las columnas de los archivos CSV en los campos de entrada a continuación de acuerdo con sus etiquetas',
				columnHeader: '{name} columna',
				members: {
					clearMembers: 'Limpiar miembros existentes',
				},
			},

			tokens: {
				tokens: 'Token | Tokens',
				allTokens: 'Todos los tokens',
				expires: 'Expira en',
				popupMessage:
					'Descargue su archivo de clave ahora o copielo. Si no descarga el archivo de clave ahora, no podrá recuperar su clave de token de nuevo. Para ayudar a proteger su seguridad, almacene su clave de token de forma segura y no la comparta.',
				tokenCreated: '¡Su token ha sido creado con éxito!',
			},

			triggers: {
				triggers: 'Desencadenador | Desencadenadores',
				allTriggers: 'Todos los desencadenadores',
				type: 'Tipo',
				schema: 'Esquema',
				newTrigger: 'Nuevo desencadenador',
				newTriggerDescription:
					'Elija una plantilla para comenzar o comience desde cero con un lienzo en blanco',
				event: 'En evento',
				onEventDescription: 'Un planificador de esquema JSON basado en eventos',
				cron: 'En tiempo',
				atTimeDescription: 'Un planificador de esquema JSON basado en tiempo',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Casos',
				caseFiles: 'Archivos de caso',
				caseComments: 'Comentarios de caso',
				caseLinks: 'Enlaces de caso',
				call: 'Llamada',
				relatedCases: 'Casos relacionados',
				expression: 'Expresión',
				timeout: 'Tiempo de espera',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Historial de ejecución',
					startedAt: 'Inicio',
					result: 'Resultado',
				},
				recordCall: 'Grabar llamada',
			},
		},
		system: {
			system: 'Sistema',
			changelogs: {
				changelogs: 'Registro de cambios | Registros de cambios',
				objects: 'Objeto | Objetos',
				daysToStore: 'Días para almacenar',
				storage: 'Descargar a',
				logs: {
					logs: 'Registro | Registros',
					actions: 'Operación | Operaciones',
					records: 'ID de registro | IDs de registros',
					actionType: {
						[LoggerAction.Create]: 'Crear',
						[LoggerAction.Delete]: 'Eliminar',
						[LoggerAction.Update]: 'Editar',
					},
				},
				period: {
					period: 'Período',
					options: {
						daily: 'Diario',
						weekly: 'Semanal',
						fortnightly: 'Quincenal',
						monthly: 'Mensual',
					},
				},
			},
			configuration: {
				configuration: 'Configuración | Configuraciones',
				parameter: 'Parámetro',
			},
			globalVariables: {
				globalVariables: 'Variable global | Variables globales',
				encrypted: 'Encriptado',
				valueInfo: 'Ingrese el valor solo si desea editar',
				newTitle: 'Nueva variable global',
				editTitle: 'Editar variable global',
			},
		},

		pagination: {
			rowsPerPage: 'Filas por página',
		},
	},

	filters: {
		team: 'Equipo',
		queueType: 'Tipo de cola',
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Descargar archivos',
			filesLoaded: 'Archivos cargados',
			zippingProgress: 'Progreso de compresión',
		},
	},

	errorPages: {
		goToHome: 'Ir a la página de inicio',
		page403: {
			title: 'Acceso denegado',
			text: 'Lo sentimos, no tiene suficientes privilegios para ver esta página.',
		},
		page404: {
			title: 'Parece que se perdió',
			text: 'Lo sentimos, no podemos encontrar la página que desea.',
		},
	},

	icon: {
		docs: 'Documentación',
		logout: 'Cerrar sesión',
		account: 'Cuenta',
		appNavigator: 'Navegador de aplicaciones',
		settings: 'Configuración',
	},

	iconHints: {
		upload: 'Subir',
		reload: 'Recargar tabla',
		edit: 'Editar',
		delete: 'Eliminar',
		deleteAll: 'Eliminar todos los elementos',
		deleteSelected: 'Eliminar {count} elementos seleccionados',
		deleteFiltered: 'Eliminar todos los elementos filtrados',
		resetAll: 'Restablecer todos los miembros',
		resetSelected:
			'Restablecer {count} miembro seleccionado | Restablecer {count} miembros seleccionados',
		resetFiltered: 'Restablecer todos los miembros filtrados',
		generate: 'Generar',
		add: 'Añadir',
		history: 'Historial',
		download: 'Descargar',
		downloadAll: 'Descargar todos',
		draggable: 'Arrastrable',
		play: 'Reproducir',
		pause: 'Pausar',
		resume: 'Resumir',
		close: 'Cerrar',
		change: 'Cambiar',
		volume: 'Volumen',
		stop: 'Detener',
		members: 'Miembros',
		moveUp: 'Mover arriba',
		moveDown: 'Mover abajo',
		nextPage: 'Página siguiente',
		prevPage: 'Página anterior',
		expand: 'Expandir',
		collapse: 'Colapsar',
	},
	errors: {
		invalidJson: 'JSON inválido',
	},
	reusable: {
		time: {
			t15m: '15 min',
			t30m: '30 min',
			t45m: '45 min',
			t1h: '1 hora',
			t3h: '4 horas',
			t6h: '6 horas',
		},
	},
};
